import { Navigate, Outlet } from 'react-router-dom';

import { useAuth } from '@/contexts/AuthContext';
import { Path } from '@/enums';

const AdminRoute = () => {
  const { token, profile, profileLoading } = useAuth();

  if (!token) {
    return <Navigate to={Path.Login} replace />;
  }

  if (profileLoading) {
    return null;
  }

  if (!profile) {
    return <Navigate to={Path.Login} replace />;
  }

  if (!profile.isAdmin) {
    return <Navigate to={Path.Unauthorized} replace />;
  }

  return <Outlet />;
};

export default AdminRoute;
